import React, { useEffect, useRef, useState } from "react";

import { useAPIs } from "../../apis/APIsConfig";
import { getBPMSExternalLogin, saveBeneficio } from "../../services/benefits";
import Constants from "../../utils/constants";
import { useGlobalStore } from "../../utils/global";
import { useForm } from "../../utils/hooks";
import { fileToBase64 } from "../../utils/utilities";
import Accordion from "../common/Accordion";
import FileUploader from "../common/FileUploader";
import { useNavigate } from "react-router-dom";
import { getAfiliado } from "../../services/profile";
import { getObtenerValorPorCodigo } from "../../services/parameters";

export function Step3({ ...props }) {
  useAPIs();
  const navigate = useNavigate();
  const { showNotification } = useGlobalStore();
  const [
    formState,
    setError,
    changeHandler,
    resetAll,
    resetErrors,
    setInitialData,
  ] = useForm({
    documentos: null,
    terminos: false,
  });
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true
      
    }
  }, []);

  function save() {
    console.info(props, formState.data.documentos);
    saveBeneficio(props.codBeneficio, formState.data.documentos).then((res) => {
      if (res && res.data.successed) {
        showNotification({
          isError: false,
          title: "Beneficio guardado satisfactoriamente",
          duration: 2000,
        });

        props.cancel();
      } else {
        showNotification({
          isError: false,
          title: res.data.message[0].message,
          duration: 2000,
        });
      }
    });
  }

  function disableButton() {
    return (
      !formState.data.terminos ||
      !formState.data.documentos ||
      !formState.data.documentos?.length
    );
  }

  return (
    <>
      <div className="accordion-container">
        <Accordion title="Subir Archivo">
          <div className="description">
            <p className="text-body-1 text-gray-70 font-body font-normal mb-6">
              Favor de adjuntar los documentos listados en los requisitos.
            </p>
            <FileUploader
              multiple={true}
              maxSizeMB={2}
              onFileSelectSuccess={(files) => {
                if (files && files.length) {
                  let docs: any[] = [];
                  new Promise((resolve) => {
                    files.forEach(async (doc: File) => {
                      docs.push({
                        documentoName: doc.name,
                        documentoBase64: (await fileToBase64(doc)).split(
                          ";base64,"
                        )[1],
                      });
                      resolve(docs);
                    });
                  }).then((res) => {
                    changeHandler("documentos", res)();
                  });
                } else {
                  changeHandler("documentos", null)();
                }
              }}
              onFileSelectError={({ error }) => {
                showNotification({
                  title: "Error",
                  message: error,
                  isError: true,
                  duration: 0,
                });
              }}
            />
          </div>
        </Accordion>
      </div>
      <form className="w-full block pt-8">
        <label className="checkbox-term">
          <input
            type="checkbox"
            onChange={changeHandler("terminos")}
            value="aceptado"
          />{" "}
          <p></p>
        </label>
        <label className="checkbox-term"><p>Acepto los{" "}<span>Término y Condiciones</span></p></label>
      </form>
      <div className="grid grid-cols-2 gap-4 md:gap-6 pt-8">
        <button
          onClick={() => props.prev()}
          className="btn btn-secondary btn-large w-full"
        >
          Volver
        </button>
        <button
          className="btn btn-primary btn-large w-full"
          onClick={() => save()}
          disabled={disableButton()}
        >
          Crear Solicitud
        </button>
      </div>
    </>
  );
}
